module.exports = __webpack_public_path__ + "static/img/worthFour.7d24b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/worthFour.png
// module id = vuLv
// module chunks = 3